export default __webpack_public_path__ + "static/media/Fullstack_JS_Certification.3d84b83c.png";